var React = require('react');

function BgInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 12C0 5.37258 5.37258 0 12 0H98C114.569 0 128 13.4315 128 30V116C128 122.627 122.627 128 116 128H30C13.4315 128 0 114.569 0 98V12Z","fill":"white"}));
}

BgInline.defaultProps = {"id":"main","width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = BgInline;

BgInline.default = BgInline;
